const tracking = object => {
  let eventActionCategory = object.eventCategory
    ? object.eventCategory
    : undefined;
  let eventActionValue = object.eventAction ? object.eventAction : undefined;
  let eventLabelValue = object.eventLabel ? object.eventLabel : undefined;
  let eventValueValue = object.eventValue ? object.eventValue : undefined;

  let eventObject = {
    event: "interactionevent",
    eventcategory: eventActionCategory ? eventActionCategory : "new pro form",
    eventaction: eventActionValue ? eventActionValue : "",
    eventlabel: eventLabelValue ? eventLabelValue : ""
  };

  // if (eventLabelValue) {
  //   eventObject.eventlabel = eventLabelValue;
  // }

  if (eventValueValue) {
    eventObject.eventvalue = eventValueValue;
  }

  try {
    window.dataLayer = window.dataLayer || [];

    if (eventActionValue) {
      window.dataLayer.push(eventObject);
    }
  } catch (error) {
    console.warn(error);
  }
};

export default tracking;
